import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import ProgramFollowCard from './ProgramFollowCard';
import CenterFollowModal from '../../Model/Individual/MySettingModel/CenterFollowModal';

export default function ProgramFollowBox(props) {
  const { follows, followers, onClickFollow } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [followStoreIds, setFollowStoreIds] = useState([]);
  const [isFollow, setIsFollow] = useState(true);
  const [clickData, setClickData] = useState(undefined);
  const [isClickedFollowSearch, setIsClickedFollowSearch] = useState(false);

  // 팔로우 중인 업체 키 추출 //
  useEffect(() => {
    const storeIds = [];

    for (const data of follows) {
      storeIds.push(data.storeId);
    }

    setFollowStoreIds(storeIds);
  }, [follows])

  // 팔로우 카드 액션 클릭시 (팔로우 찾아보기) //
  function onClickFindFollow() {
    setClickData(undefined);
    setIsFollow(true);
    setIsClickedFollowSearch(true);
  }

  // 팔로워 카드 액션 클릭시 (팔로우 관리하기) //
  function onClickManageFollow() {
    setClickData(undefined);
    setIsFollow(false);
    setIsClickedFollowSearch(true);
  }

  //// 팔로우 타일 클릭시 //
  //function onClickFollowTile(data) {
  //  setClickData(data);
  //  setIsFollow(true);
  //  setIsClickedFollowSearch(true);
  //}

  //// 팔로워 타일 클릭시 //
  //function onClickFollowerTile(data) {
  //  setClickData(data);
  //  setIsFollow(false);
  //  setIsClickedFollowSearch(true);
  //}

  // 휴지통 클릭시 (팔로우 끊기 / 팔로워 삭제 — share/delete 위임) //
  function onClickDeleteTile(data, isFollowVariant) {
    onClickFollow(data, isFollowVariant);
  }

  // 모달에서 신청 / 승인 / 취소 클릭시 — 모달은 닫지 않고 유지 //
  function onClickFollowButton(data) {
    onClickFollow(data, isFollow);
  }

  return (
    <TopLevelWrapper>
      {
        isClickedFollowSearch &&
        <CenterFollowModal
          isExercise={true}
          isFollow={isFollow}
          followStoreIds={followStoreIds}
          follows={follows}
          followers={followers}
          initialClickData={clickData}
          onClickFollow={onClickFollowButton}
          close={() => setIsClickedFollowSearch(false)} />
      }
      <SectionHeader>
        <SectionLabelText color={theme.primary}>{t('myStoreSetting.program.sectionLabel')}</SectionLabelText>
        <SectionTitleText color={theme.text}>{t('myStoreSetting.program.title')}</SectionTitleText>
      </SectionHeader>
      <CardRow>
        <ProgramFollowCard
          variant='follow'
          tiles={follows}
          //onClickTile={onClickFollowTile}
          onClickDelete={(data) => onClickDeleteTile(data, true)}
          onClickAction={onClickFindFollow} />
        <ProgramFollowCard
          variant='follower'
          tiles={followers}
          //onClickTile={onClickFollowerTile}
          onClickDelete={(data) => onClickDeleteTile(data, false)}
          onClickAction={onClickManageFollow} />
      </CardRow>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: stretch;

  margin-top: 36px;

  gap: 15px;

  width: 100%;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 10px;

  width: 100%;
`;

const CardRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: stretch;

  gap: 20px;

  width: 100%;
`;

const SectionLabelText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  margin: 0;

  color: ${props => props.color};

  transition: all 0.3s ease-in-out;
`;

const SectionTitleText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  margin: 0;

  color: ${props => props.color};

  transition: all 0.3s ease-in-out;
`;